module.exports = __webpack_public_path__ + "img/_qft-dagger-up_.0de868a5.svg";